export default __webpack_public_path__ + "4a056f7015aa42627e362f3ccec50cf8.png";